module.exports = __webpack_public_path__ + "static/img/satinal.49fac47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/satinal.jpg
// module id = lTAG
// module chunks = 1